var exports = {
  "D": "xfd349460--3040ea--carousel",
};

module.exports = exports;
